import { gql } from '@/__generated__';

export const customersDocument = gql(/* GraphQL */ `
  query Customers(
    $where: CustomerWhereInput
    $skip: Int
    $take: Int
    $orderBy: [CustomerOrderByWithRelationInput!]
  ) {
    customers(where: $where, skip: $skip, take: $take, orderBy: $orderBy) {
      id
      pageId
      name
      email
      avatar
      createdAt
      updatedAt
      active
      reason
      _count {
        orders
        messages
        addresses
        refunds
      }
    }
  }
`);

export const countCustomersDocument = gql(/* GraphQL */ `
  query CountCustomers($where: CustomerWhereInput!) {
    countCustomers(where: $where)
  }
`);
